import React from 'react';
import { NavLink, useLocation } from 'react-router-dom';

/*  ▸ Icons from react‑icons/FA  (Font Awesome subset)  */
import {
  FaFacebookF,
  FaInstagram,
  FaLinkedinIn,
} from 'react-icons/fa';

export default function Navbar() {
  const location = useLocation();
  const isGetStartedPage = location.pathname.startsWith('/getstarted');

  return (
    <header className="navbar gyo-navbar">
      <div className="container navbar-content">
        {/* Brand */}
        <NavLink to="/" className="logo gyo-logo">
          <span className="gyo-logo-mark" aria-hidden="true">
            <span className="gyo-logo-mark-inner">G</span>
          </span>
          <span className="gyo-logo-text">
            Grow<span className="gyo-logo-accent">YourOnlyFans</span>
            <span className="gyo-logo-tld">.com</span>
          </span>
        </NavLink>

        {/* Social icons */}
        <nav className={`contact-social gyo-social ${isGetStartedPage ? 'getstarted-social' : ''}`}>
          <a
            href="https://www.facebook.com/profile.php?id=61563398802315"
            target="_blank"
            rel="noreferrer"
            aria-label="Facebook"
          >
            <FaFacebookF />
          </a>
          <a
            href="https://www.instagram.com/growyouronlyfans"
            target="_blank"
            rel="noreferrer"
            aria-label="Instagram"
          >
            <FaInstagram />
          </a>
          <a
            href="https://www.linkedin.com/company/growyouronlyfans"
            target="_blank"
            rel="noreferrer"
            aria-label="LinkedIn"
          >
            <FaLinkedinIn />
          </a>
        </nav>
      </div>
    </header>
  );
}
